export const contentTableConfig = {
  title: '主体列表',
  propList: [
    {
      prop: 'corpId',
      label: '主体ID',
      minWidth: '80'
    },
    {
      prop: 'corpName',
      label: '主体简称',
      minWidth: '80'
    },
    {
      prop: 'fullName',
      label: '主体全称',
      minWidth: '80'
    },
    {
      prop: 'expireTime',
      label: '认证到期时间',
      minWidth: '80'
    },
    {
      label: '操作',
      minWidth: '80',
      slotName: 'handler'
    }
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
